import { render, staticRenderFns } from "./RegisterMailAddress.vue?vue&type=template&id=1a2482f2&lang=pug&"
import script from "./RegisterMailAddress.vue?vue&type=script&lang=js&"
export * from "./RegisterMailAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports